import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-34979199"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "form-content"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_3 = {
  key: 1,
  class: "process-content"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WhitelabelPrimaryLogo = _resolveComponent("WhitelabelPrimaryLogo")!
  const _component_ClinicLogo = _resolveComponent("ClinicLogo")!
  const _component_ProfileInputFields = _resolveComponent("ProfileInputFields")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_BaseButton = _resolveComponent("BaseButton")!
  const _component_SignupSpinner = _resolveComponent("SignupSpinner")!

  return (_openBlock(), _createElementBlock("form", {
    class: "signup-form",
    onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitSignupRequest && _ctx.submitSignupRequest(...args)), ["prevent"]))
  }, [
    (_ctx.isStatusNotSubmitted)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_ctx.useOrgLogo)
            ? (_openBlock(), _createBlock(_component_WhitelabelPrimaryLogo, { key: 0 }))
            : (_ctx.isBrandedMode && _ctx.clinic)
              ? (_openBlock(), _createBlock(_component_ClinicLogo, {
                  key: 1,
                  clinic: _ctx.clinic
                }, null, 8, ["clinic"]))
              : _createCommentVNode("", true),
          _createElementVNode("p", {
            class: _normalizeClass({'dark-mode': _ctx.darkStyle})
          }, _toDisplayString(_ctx.titleText), 3),
          _createVNode(_component_ProfileInputFields, {
            controller: _ctx.profileController,
            passwordController: _ctx.passwordController,
            includeSignupFields: "",
            inputIds: _ctx.signupFields,
            requiredInputIds: _ctx.requiredFields,
            emailError: _ctx.emailError,
            darkStyle: _ctx.darkStyle,
            onProfileChange: _ctx.onProfileChange
          }, null, 8, ["controller", "passwordController", "inputIds", "requiredInputIds", "emailError", "darkStyle", "onProfileChange"]),
          _createVNode(_component_Checkbox, {
            onClick: _ctx.agreeToTerms,
            checked: _ctx.policyAccepted
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", {
                class: _normalizeClass({'dark-mode': _ctx.darkStyle})
              }, [
                _createTextVNode(_toDisplayString(this.$mhat("SignupForm.UseOfWebsiteMessage")) + " ", 1),
                _hoisted_2,
                _createTextVNode(" " + _toDisplayString(this.$mhat("SignupForm.Our")) + " ", 1),
                _createElementVNode("a", {
                  class: "terms-link",
                  onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.termsClick && _ctx.termsClick(...args)), ["prevent"]))
                }, _toDisplayString(this.$mhat("SignupForm.TermsOfUseLinkText")), 1),
                _createTextVNode(" " + _toDisplayString(this.$mhat("SignupForm.And")) + " ", 1),
                _createElementVNode("a", {
                  class: "terms-link",
                  onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.policyClick && _ctx.policyClick(...args)), ["prevent"]))
                }, _toDisplayString(this.$mhat("SignupForm.PrivacyPolicyLinkText")), 1)
              ], 2)
            ]),
            _: 1
          }, 8, ["onClick", "checked"]),
          _createVNode(_component_BaseButton, {
            type: "submit",
            primary: "",
            disabled: !_ctx.canSubmit
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(this.$mhat("SignupForm.CreateAccountButtonText")), 1)
            ]),
            _: 1
          }, 8, ["disabled"])
        ]))
      : (_ctx.useInlineSpinner)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_SignupSpinner, {
              "is-loading": _ctx.loadingQueue.isLoading || _ctx.isStatusPending,
              "is-error": _ctx.isStatusError,
              "is-success-partial": _ctx.isStatusSuccessPartial,
              clinic: _ctx.clinic,
              "dark-style": _ctx.darkStyle,
              "patient-email": _ctx.profileController.userProfile.email,
              "patient-name": _ctx.profileController.userProfile.firstName,
              onReset: _cache[2] || (_cache[2] = ($event: any) => (_ctx.resetForm()))
            }, {
              default: _withCtx(() => [
                _renderSlot(_ctx.$slots, "default", {}, undefined, true)
              ]),
              _: 3
            }, 8, ["is-loading", "is-error", "is-success-partial", "clinic", "dark-style", "patient-email", "patient-name"])
          ]))
        : _createCommentVNode("", true)
  ], 32))
}